/// <amd-module name="WorkItemsHub/Utils/WorkItemsXhrNavigationUtils" />
import * as UrlUtils from "WorkItemsHub/Utils/UrlUtils";
import { FastPageSwitch, onClickFPS } from "VSS/Platform/FPS"
import { IVssPageContext } from 'VSS/Platform/Context';

/**
 * Navigate to work item creation page without page refresh.
 */
export function navigateToNewWorkItemForm(pageContext: IVssPageContext, projectName: string, workItemType: string): void {
    FastPageSwitch(pageContext, UrlUtils.getCreateWorkItemUrl(pageContext, projectName, workItemType), true);
}

/**
 * Navigate to work item edit page without page refresh.
 */
export function navigateToWorkEditWorkItemForm(pageContext: IVssPageContext, projectName: string, workItemId: number,
    event?: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>): boolean | void {

    const url = UrlUtils.getEditWorkItemUrl(pageContext, projectName, workItemId);
    return onClickFPS(pageContext, url, true, event);
}
